import { render, staticRenderFns } from "./Sns.vue?vue&type=template&id=66f67a98&"
import script from "./Sns.vue?vue&type=script&lang=js&"
export * from "./Sns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports